import React, { useEffect } from "react"
import { connect } from "react-redux";
import { InfoBoxes } from "../../info-boxes/InfoBoxes";
import { withMainLayout } from "../../view/LayoutHOCs";
import * as layoutService from "../../view/layoutService";
import ConfigChangesTableSection from "./ConfigChangesTableSection";


const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Devices",
        redirectTo: "/devices",
    },
    {
        text: "Configuration Changes",
        redirectTo: "/configuration-changes",
    },
]

function ConfigChangesPage(props) {

    useEffect(() => {
        layoutService.setPageTitle("Device Configuration Changes")
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [])

    return (
        <>
            <InfoBoxes />
            <ConfigChangesTableSection />
        </>
    );
}


export default withMainLayout(connect()(ConfigChangesPage));